import LoginFormV2 from '../components/LoginFormV2';

const LoginV2 = ({ token }: { token?: string }) => {
	return <LoginFormV2 token={token} />;
};

export default LoginV2;
